import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Slide,
  Box,
  CircularProgress,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import useStyles from "./styles";
import { ReactComponent as TickIcon } from "svgs/light/tick-active.svg"; // Assuming this exists or similar
import crowdService from "services/crowdService";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface DownloadFileModalProps {
  open: boolean;
  onClose: () => void;
  onDownload: (type: "payment_list" | "job_id_list") => void;
  entityid: string;
  start_date: string;
  end_date: string;
}

const DownloadFileModal: React.FC<DownloadFileModalProps> = ({
  open,
  onClose,
  onDownload,
  entityid,
  start_date,
  end_date,
}) => {
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState<
    "payment_list" | "job_id_list"
  >("payment_list");
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    // onDownload(selectedOption);
    setLoading(true);
    try {
      if (selectedOption === "payment_list") {
        await handledownloadPaymentList();
      } else {
        await downloadPaymentListByJobId();
      }
      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handledownloadPaymentList = async () => {
    await crowdService.downloadPaymentList(entityid!, start_date, end_date);
  };

  const downloadPaymentListByJobId = async () => {
    await crowdService.downloadPaymentListByJobId(
      entityid!,
      start_date,
      end_date,
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "10px",
          minWidth: "400px",
        },
      }}
    >
      <DialogTitle
        sx={{ fontWeight: 700, fontSize: "18px", fontFamily: "Lexend" }}
      >
        Download File
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body2"
          sx={{ marginBottom: "20px", color: "#666", fontFamily: "Lexend" }}
        >
          Select the required file to download
        </Typography>

        <div
          className={`${classes.selectionBox} ${
            selectedOption === "payment_list"
              ? classes.selectionBoxSelected
              : ""
          }`}
          onClick={() => setSelectedOption("payment_list")}
        >
          <span className={classes.selectionTitle}>Payments List</span>
          {selectedOption === "payment_list" && (
            <div
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: "#7152F3",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: "white",
                }}
              ></div>
            </div>
          )}
          {selectedOption !== "payment_list" && (
            <div
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                border: "2px solid #E0E0E0",
              }}
            ></div>
          )}
        </div>

        <div
          className={`${classes.selectionBox} ${
            selectedOption === "job_id_list" ? classes.selectionBoxSelected : ""
          }`}
          onClick={() => setSelectedOption("job_id_list")}
        >
          <span className={classes.selectionTitle}>
           Overall Payments with Job-wise Stats
          </span>
          {selectedOption === "job_id_list" && (
            <div
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: "#7152F3",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: "white",
                }}
              ></div>
            </div>
          )}
          {selectedOption !== "job_id_list" && (
            <div
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                border: "2px solid #E0E0E0",
              }}
            ></div>
          )}
        </div>
      </DialogContent>
      <DialogActions sx={{ padding: "16px 24px" }}>
        <Button
          onClick={onClose}
          className={classes.buttonSecondaryStyle}
          variant="outlined"
          style={{ width: "50%" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDownload}
          className={classes.buttonPrimaryStyle}
          variant="contained"
          style={{ width: "50%" }}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} style={{ color: "white" }} />
          ) : (
            "Download"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadFileModal;
